// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-order-button {
  margin: 12px;
}

ion-button {
  width: 58%;
}

.price {
  color: white;
}

.wrapper {
  background-color: var(--main-background);
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.vertical-line {
  height: 55%;
  width: 0.6px;
  margin-inline: 10px;
  background-color: #fff;
}

.quantity {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/to-order-button/to-order-button.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AACA;EACE,UAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,wCAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAGF","sourcesContent":[".add-to-order-button {\n  margin: 12px;\n}\nion-button {\n  width: 58%;\n}\n.price {\n  color: white;\n}\n\n.wrapper {\n  background-color: var(--main-background);\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n}\n\n.vertical-line {\n  height: 55%;\n  width: 0.6px;\n  margin-inline: 10px;\n  background-color: #fff;\n}\n\n.quantity {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
